import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminApi, auth } from "@/lib/adminApi";

export default function RequireAdmin({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(auth.isAuthenticated() ? "checking" : "out");

  useEffect(() => {
    let mounted = true;
    if (!auth.isAuthenticated()) return;
    adminApi
      .get("/admin/me")
      .then(() => {
        if (mounted) setStatus("in");
      })
      .catch(() => {
        auth.clear();
        if (mounted) setStatus("out");
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-[#666]">
        Prüfe Anmeldung…
      </div>
    );
  }
  if (status === "out") {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
